// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-left[data-v-588c9bc0] {\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
